/** @jsxImportSource @emotion/react */
import Field, { DataSource } from "./Field";

// * Facility value of a layer without an allocation, mirrors NO_FACILITY in the backend
export const NO_FACILITY = "none";

/**
 * Shows whether a meta field holds the layer's current facility.
 *
 * For "done at a facility" stamps (e.g. closed_inbound = "A"): the layer only
 * counts as done while it is still in that facility. Counterpart of the
 * `not_current_facility` meta filter method.
 */
class LayerMetaAtCurrentFacilityField extends Field {
    field_type = "layer_meta_at_current_facility_field";

    backend_table = "layer_meta";

    get_backend_fieldname(): string[] {
        return [`${this.backend_table}.${this.fieldname_getter}`, "latest_location.facility"];
    }

    // * Sorting would order by the raw facility value, not by the shown state
    is_sortable(): boolean {
        return false;
    }

    set_value(datasource: DataSource): this {
        const stamped = datasource?.layer?.[this.fieldname_getter];
        const currentFacility = datasource?.layer?.latest_location?.facility || NO_FACILITY;
        this.value = stamped && stamped === currentFacility ? "Yes" : null;
        this.config = datasource?.config;
        this.value = this.value_filter(this.value, datasource);
        return this;
    }
}

export default LayerMetaAtCurrentFacilityField;
